import Link from "next/link";

import { SITE_NAME } from "@shared/constants";

type Props = React.AnchorHTMLAttributes<HTMLAnchorElement> & {
  baseUrl?: string;
};

export default function LogoLink({ baseUrl = "", ...props }: Props) {
  return (
    <Link href={`${baseUrl}/`} className="site-header__logo__link" {...props}>
      <span className="sr-only">{SITE_NAME}</span>
    </Link>
  );
}
